import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IContributionEmployee } from "src/models/HumanResources/ContributionEmployees.models";

interface ContributionEmployeeState {
  contributionEmployees: IContributionEmployee[];
  contributionEmployeeToEdit: IContributionEmployee | null;
}

const initialState: ContributionEmployeeState = {
  contributionEmployees: [],
  contributionEmployeeToEdit: null,
};

const ContributionEmployeeSlice = createSlice({
  name: "ContributionEmployee",
  initialState,
  reducers: {
    setContributionEmployeeList: (
      state,
      action: PayloadAction<IContributionEmployee[]>
    ) => {
      state.contributionEmployees = action.payload;
    },
    concatListContributionEmployee: (
      state: ContributionEmployeeState,
      action: PayloadAction<IContributionEmployee[]>
    ) => {
      state.contributionEmployees = [
        ...state.contributionEmployees.concat(action.payload),
      ];
    },
    setContributionEmployeeToEdit: (
      state,
      action: PayloadAction<IContributionEmployee | null>
    ) => {
      state.contributionEmployeeToEdit = action.payload;
    },
    addContributionEmployee: (
      state,
      action: PayloadAction<IContributionEmployee>
    ) => {
      state.contributionEmployees.push(action.payload);
    },
    updateContributionEmployee: (
      state,
      action: PayloadAction<IContributionEmployee>
    ) => {
      let itemIndex = state.contributionEmployees.findIndex(
        item =>
          item.contributionEmployeeId === action.payload.contributionEmployeeId
      );
      if (itemIndex !== -1)
        state.contributionEmployees[itemIndex] = action.payload;
    },
    deleteContributionEmployee: (state, action: PayloadAction<number>) => {
      const newArray = state.contributionEmployees.filter(
        item => item.contributionEmployeeId !== action.payload
      );
      state.contributionEmployees = newArray;
    },
  },
});

export const {
  setContributionEmployeeList,
  concatListContributionEmployee,
  setContributionEmployeeToEdit,
  addContributionEmployee,
  updateContributionEmployee,
  deleteContributionEmployee,
} = ContributionEmployeeSlice.actions;

export default ContributionEmployeeSlice.reducer;
